export const ACTIONS = {
	CLEAR_FORMAT_CODE_ERROR: 'CLEAR_FORMAT_CODE_ERROR',
	REMOVE_AUTO_DETECT_ENTRY: 'REMOVE_AUTO_DETECT_ENTRY',
	RESOLVE_FORMAT_CODE: 'RESOLVE_FORMAT_CODE',
	SET_AUTO_DETECT_ENTRY: 'SET_AUTO_DETECT_ENTRY',
	SET_COPIED_TO_CLIPBOARD: 'SET_COPIED_TO_CLIPBOARD',
	SET_IS_WRAPPED: 'SET_IS_WRAPPED',
	SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS: 'SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS',
	START_FORMAT_CODE: 'START_FORMAT_CODE',
};
